import React from "react";
import auth, { getProxyPercentWidth } from "../../js/auth";
import languages from "../../langs/languages";
import { connect } from "react-redux";
import { getMenuCategoryOptions } from "../../js/tables-overview";
import { getMenuCategory } from "../../js/admin";

class MenuItemButton extends React.Component {
    constructor(props) {
        super(props);
        this.myRef = React.createRef();
    }

    getDomNode() {
        return this.myRef.current;
    }

    componentDidMount() {
    }

    componentWillUnmount() {
    }


    render() {
        const { category, menuItem, myRef } = this.props;
        this.myRef = myRef || this.myRef;

        const imageSrc = menuItem.bigImage ? getProxyPercentWidth(30, `${auth.server}/${auth.war}/tableService/${localStorage.restaurantSelected}/getImage/${menuItem.bigImage}?timestamp=${menuItem.bigImageTimestamp}&instance=${localStorage.instance}`) :
            menuItem.image ? getProxyPercentWidth(30, `${auth.server}/${auth.war}/tableService/${localStorage.restaurantSelected}/getImage/${menuItem.image}?timestamp=${menuItem.imageTimestamp}&instance=${localStorage.instance}`) : '';

        return (
            <div ref={this.myRef} key={menuItem.id} id={menuItem.id} category={category.id} className="kioskMenuItem">
                <div key={menuItem.id}
                    className="kioskMenuItemButton"
                >
                    <div className="kioskMenuItemImageWrapperWrapper">
                        <div key={0} className="kioskMenuItemImageWrapper"
                            style={{
                            }}
                        >
                            <div className="kioskMenuItemImage"
                                key={0}
                                alt=""
                                style={{
                                    backgroundImage: `url(${imageSrc})`,
                                }}
                                onClick={() => this.props.onClick(menuItem, this.getFirstQuantity(menuItem))}
                            />
                        </div>
                    </div>
                </div>
                <div className="kioskMenuItemTitle">{`${menuItem.name}`}</div>
                <div className="kioskMenuItemDescription">{`${menuItem.description != "N/A" ? menuItem.description : ""}`}</div>
                <div className="kioskQuantities">
                    {this.getQuantityLabels(menuItem)}

                </div>
            </div>
        );
    }

    getFirstQuantity = (menuItem) => {
        const quantities = menuItem.availableQuantities;
        return quantities.filter(q => q?.settings?.kiosk?.kiosk?.enabled !== false)[0].quantity;
    }

    getQuantityLabels = (menuItem) => {
        const quantities = menuItem.availableQuantities;
        return quantities.filter(q => q?.settings?.kiosk?.kiosk?.enabled !== false).map((q, index) => {
            const minExtra = getMenuCategoryOptions(menuItem).filter(a => a.optionType === "one").map(a => {
                const category = getMenuCategory(a.addition.id);
                const itemPrices = category.activeMenuItems.filter(m => m.kiosk).map(m => {
                    const prices = m.availableQuantities.filter(q => q?.settings?.kiosk?.kiosk?.enabled !== false).map(a => Number(a.price));
                    return prices.length ? prices.reduce((a, b) => Math.min(a, b)) : Infinity;
                }).filter(p => isFinite(p));
                return itemPrices.length ? itemPrices.reduce((a, b) => Math.min(a, b)) : 0;
            }).reduce((a, b) => a + b, 0);
            const price = Number(q.price) + Number(minExtra);
            return (
                <div key={index} className="kioskQuantity" onClick={() => this.props.onClick(menuItem, q.quantity)}>
                    <div className="kioskQuantityPrice">
                        {price ? price + ' ' + this.props.currency : ''}
                    </div>
                    <div className="kioskAddToCartButton" onClick={this.onClick}>
                        {quantities.length == 1 ? this.props.local.addToCart : this.getQuantityLabel(menuItem, q)}
                    </div>
                </div>
            )
        })
    }

    onClick = (e) => {
        console.log(this.myRef);
    }

    getQuantityLabel = (menuItem, q) => {
        const quantity = q?.quantity || 1;
        const quantityLabel = q?.quantityType?.name;
        const quantityType = menuItem.quantityType;
        const entityType = menuItem.entityType;
        if (entityType == 'Meal' && quantityLabel != '' && quantityLabel != 'N/A')
            return quantityLabel;
        else if (entityType == 'Meal' && quantityType == 'pcs' && quantity == '1' && quantityLabel == 'N/A')
            return '';
        else
            return quantity + ' ' + (quantityType == 'pcs' ? '' : this.props.local[quantityType] + ' ') + (quantityLabel != '' && quantityLabel != 'N/A' ? "(" + quantityLabel + ")" : "");
    }



}


const mapStateToProps = (props, state) => {
    if (props.rootReducer.myStatus) {
        return {
            currency: props.rootReducer.myStatus.restaurant_base_currency.name,
            restaurant: props.rootReducer.restaurant,
            myStatus: props.rootReducer.myStatus,
            menuCategories: props.rootReducer.menuCategories,
            admin_local: props.rootReducer.admin_local,
            local: props.rootReducer.local,
            speechRecognitionOn: props.rootReducer.speechRecognitionOn,
            ai: props.rootReducer.ai,
            speechRecognitionAvailable: props.rootReducer.speechRecognitionAvailable,
            tables: props.rootReducer.tables,
            deliveryUsers: []
        };
    }
    return {};
};

export default connect(mapStateToProps)(MenuItemButton);
